import { render, staticRenderFns } from "./input-radio.vue?vue&type=template&id=f0a967f6&scoped=true"
import script from "./input-radio.vue?vue&type=script&lang=js"
export * from "./input-radio.vue?vue&type=script&lang=js"
import style0 from "./input-radio.vue?vue&type=style&index=0&id=f0a967f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a967f6",
  null
  
)

export default component.exports